<template>
  <div v-if="opqIf">
    <infobulle :descriptionPopup="descriptionPopup">
      <label :for="idInner" v-if="libelleLong"><div v-html="libelleLong" class="mb-1"></div></label>

      <template v-if="modeAffichageCatalogue == 'radio'">
        <v-radio-group
          :id="idInner"
          v-bind="$attrs"
          @change="handleChange"
          class="ml-3 mt-0"
          :rules="catalogueRules"
          :value="value"
          dense
          :multiple="multiple"
          :loading="updating"
          :disabled="updating || disabled"
        >
          <div v-for="item in valeurs" :key="item.value">
            <v-radio :value="item.value" class="my-1">
              <template v-slot:label>
                <span v-html="item.text"></span>
              </template>
            </v-radio>
            <infobulle :descriptionPopup="item.descriptionPopup"></infobulle>
          </div>
        </v-radio-group>
      </template>

      <template v-if="modeAffichageCatalogue == 'checkbox'">
        <div v-for="item in valeurs" :key="item.value">
          <v-checkbox :value="item.value" hide-details @change="handleChange" v-model="checkboxValue" class="my-1" :disabled="disabled">
            <template v-slot:label>
              <div v-html="item.text"></div>
            </template>
          </v-checkbox>
          <infobulle :descriptionPopup="item.descriptionPopup"> </infobulle>
        </div>

        <v-checkbox
          class="list_counter_validator my-2 p-0"
          :input-value="checkboxValue.length > 0"
          :rules="[(v) => optional || !!v || 'Sélectionner au moins un élément']"
        ></v-checkbox>
      </template>

      <template v-if="modeAffichageCatalogue == 'autocomplete'">
        <v-autocomplete
          :id="idInner"
          :label="label"
          :style="{ width: width + 'px' }"
          :items="valeurs"
          v-bind="$attrs"
          :value="value"
          @change="handleChange"
          :rules="catalogueRules"
          outlined
          dense
          :multiple="multiple"
          :chips="multiple"
          clearable
          auto-select-first
          :disabled="updating || disabled"
        >
        </v-autocomplete>
      </template>

      <template v-if="modeAffichageCatalogue == 'select'">
        <v-select
          :id="idInner"
          :label="label"
          :value="value"
          :style="{ width: width + 'px' }"
          :items="valeurs"
          v-bind="$attrs"
          @change="handleChange"
          :rules="catalogueRules"
          outlined
          dense
          :chips="multiple"
          :multiple="multiple"
          clearable
          :disabled="updating || disabled"
        ></v-select>
      </template>
    </infobulle>
  </div>
</template>
   

<script>
import ChampBase from "@/mixins/ChampBase"
import CatalogueBase from "@/mixins/CatalogueBase"
import { Api, Queue } from "@/plugins/api"

// @group Champs
export default {
  data() {
    return {
      checkboxValue: [],
      updating: false
    }
  },
  props: {
    width: { type: String, default: "270" },
    value: [String, Array],
    code: { type: String, required: true },
    optional: Boolean,
    multiple: { type: Boolean, default: false },
    parent: { type: String },
    live: { type: Object },
    orderBy: { type: String, default: "code" },
    filter: { type: Function },
    // Liste d'objet {code: string, condition: bool}. Seulement les éléments dont le code à la condition true seront affichés dans les choix
    codeFilter: { type: Array },
    codeExclude: { type: Array },
    // Variable qui lorsqu'elle passe à false, déclenche un clear du champ
    opqIf: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false },
    id: { type: String }
  },
  mixins: [CatalogueBase, ChampBase],

  computed: {
    catalogueRules() {
      return [
        (v) => {
          if (this.optional) {
            return true
          }
          if (this.multiple) {
            return v.every((c) => this.valeurs.map((m) => m.value).indexOf(c) > -1)
          } else {
            return this.valeurs.map((m) => m.value).indexOf(v) > -1 || "Ce champ est obligatoire"
          }
        }
      ]
    }
  },

  created() {
    this.checkboxValue = this.value || []
    //this.sortCatalogue()
  },

  methods: {
    handleChange(event, priority = 1) {
      if (this.live) {
        this.updating = true
        Queue.enqueue(
          () =>
            Api.post(this.live.endpoint, {
              fileId: this.live.fileId,
              cle: this.live.cle,
              value: event
            }).finally(() => {
              this.$emit("eudo-updated", event)
              this.updating = false
            }),
          priority
        )
      }

      if (this.modeAffichageCatalogue == "checkbox") {
        this.$emit("input", this.checkboxValue)
      } else {
        this.$emit("input", event)
      }
    },
    checkAll() {
      if (this.modeAffichageCatalogue == "checkbox") {
        this.checkboxValue = this.valeurs.map((v) => v.value)
      }
      this.handleChange(
        this.valeurs.map((v) => v.value),
        8
      )
    },
    setValue(value, multiple = false) {
      if (this.modeAffichageCatalogue == "checkbox") {
        if(multiple) {
          this.checkboxValue = value
        } else {
          this.checkboxValue = [value]
        }
      }
      this.handleChange(value, 8)
    },
    setValueByCode(code) {
      let value = this.valeurs.find((fd) => fd.code == code)
      if (value) {
        this.setValue(value.value)
      }
    },
    removeValuesByCodes(codes) {
      if (this.modeAffichageCatalogue == "checkbox") {
        for (let i = 0; i < codes.length; i++) {
          let value = this.allValeurs.find((fd) => fd.code == codes[i])
          let index = this.checkboxValue.indexOf(value.value)
          if (index > -1) {
            this.checkboxValue.splice(index, 1)
          }
        }
        this.handleChange(this.checkboxValue, 8)
      }
    }
  },
  watch: {
    opqIf(newValue) {
      if (!newValue) {
        if (this.modeAffichageCatalogue == "checkbox") {
          this.checkboxValue = []
        }
        this.handleChange(null)
      }
    }
  }
}
</script>

<style>
</style>